<div class="div">
  <div class="field">
    <div class="tem-field" tabindex="-1">
      <div class="tem-field-label-row">
        <label class="tem-field-label" tabindex="-1">{{label}}<span class="tem-field-required" *ngIf="required"> *</span></label>
        <span class="tem-field-suffix" tabindex="-1">
          <ng-content select="[suffix]"></ng-content>
        </span>
      </div>
      <input nz-input [type]="type" [placeholder]="placeholder" [required]="required" [formControl]="controle" (input)="editing()">
    </div>
  </div>
  <div class="buttonicon" tabindex="-1">
    <button nz-button nzType="primary" nzShape="circle" aria-label="Botão genérico" (click)="click($event)" [disabled]="disabled" tabindex="-1">
      <generic-icon [iconName]="icon" type="google"></generic-icon>
    </button>
  </div>
</div>
